import { useEffect, useState } from 'react';
import { differenceBy } from 'lodash';
import { gtmCaptureReplaceCart } from 'api/gtm';
import { Typography, Alert, IconInfo } from '@newulife/common';
import ShadowCard from 'components/common/cards/ShadowCard';
import CartOrderTotals from 'components/common/cart/CartOrderTotals';
import { useSubscriptions } from 'contexts/SubscriptionContext';
import SubscriptionOrderProductSection from './SubscriptionOrderProductSection';
import { useRecoilValue } from 'recoil';
import { formState } from 'state';
import { useField } from 'hooks/useContentfulApi';

export default function SubscriptionOrder({ onUpdateCart }) {
  const [data] = useField('banner1Ref');
  const {
    countryInfo: { marketName, iso2: marketIso },
  } = useRecoilValue(formState);
  const {
    state: { subscriptions },
    dispatch,
  } = useSubscriptions();

  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasDispatched, setHasDispatched] = useState(false);

  const marketsUsingNewDesign = ['JP'];

  const isMarketUsingNewDesign = marketsUsingNewDesign.includes(marketIso);

  useEffect(() => {
    if (hasDispatched) {
      updateCart();
    }
  }, [hasDispatched]);

  const save = async (newSubscriptions) => {
    if (newSubscriptions) {
      setLoading(true);

      // GTM Analytics
      const data = differenceBy(subscriptions, newSubscriptions, 'ProductID');

      if (data.length !== 0) {
        const variant = 'Subscription';
        const { pathname } = window.location;

        gtmCaptureReplaceCart({ data, marketName, variant, pathname });
      }

      // Update Context
      dispatch({
        type: 'replaceSubscriptions',
        subscriptions: newSubscriptions,
      });
      setHasDispatched(true);
    } else {
      close();
    }
  };

  const updateCart = async () => {
    // Update
    await onUpdateCart();

    // Cleanup
    setLoading(false);
    setHasDispatched(false);

    // Close
    close();
  };

  const close = () => {
    setModalOpen(false);
  };

  if (!loading && subscriptions.length === 0) {
    return null;
  }

  const { item18, item23 } = data.fields;

  return (
    <ShadowCard title={item18}>
      <div className="order-summary">
        <SubscriptionOrderProductSection
          subscriptions={subscriptions}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          loading={loading}
          save={save}
          close={close}
          allowEdit={!isMarketUsingNewDesign}
        />
        <CartOrderTotals type="subscription" subscriptions={subscriptions} />
        <Alert
          sx={{
            maxWidth: 300,
            ml: 'auto',
            mt: '20px',
          }}
          icon={<IconInfo />}
        >
          <Typography as="p" variant="body2" color="inherit">
            {item23}
          </Typography>
        </Alert>
      </div>
    </ShadowCard>
  );
}
